import store from 'redux/store';

const getAppInfo = () => {
	const appInfo = store.getState().generalDetails?.appInfo || JSON.parse(localStorage.getItem('appInfo'));
	return appInfo;
};

export default getAppInfo;
